/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_SubscriptionsInputs */

const en_settings_billing_subscriptions = /** @type {(inputs: Settings_Billing_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Settings_Billing_SubscriptionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscriptions = /** @type {((inputs?: Settings_Billing_SubscriptionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_SubscriptionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_subscriptions(inputs)
});
export { settings_billing_subscriptions as "settings.billing.subscriptions" }